import { Pipe, PipeTransform } from '@angular/core';
import { litersToGallons } from '../lib/utils';

@Pipe({ name: 'volume' })
export class VolumePipe implements PipeTransform {
  public transform (volume, metricUnits) {
    if (volume == null) return;
    if (!metricUnits) volume = litersToGallons(volume);
    return volume;
  }
}
